import { useAnalyticsLogging } from "../../Shared/hooks/useAnalyticsLogging/useAnalyticsLogging";
import { loginEvent } from "./loginUtils";
export const useLoginForm = () => {
    const { createKlaviyoEvent } = useAnalyticsLogging();
    return {
        loginEvent: loginEvent(createKlaviyoEvent),
    };
};
